import { useEffect, useRef } from "react";
import { Switch } from "@progress/kendo-react-inputs";

import type { SwitchHandle, SwitchProps } from "@progress/kendo-react-inputs";

interface ToggleProps extends SwitchProps {
  testId?: string;
  title?: string;
}

export const Toggle = ({ className, testId, ...otherProps }: ToggleProps): JSX.Element => {
  const switchRef = useRef<SwitchHandle>(null);

  useEffect(() => {
    if (testId && switchRef.current?.element) {
      switchRef.current.element.setAttribute("data-testid", testId);
      const switchInput = switchRef.current.element.querySelector("input");
      if (switchInput) {
        switchInput.setAttribute("data-testid", `${testId}-input`);
      }
    }
  }, [switchRef, testId]);

  return <Switch ref={switchRef} className={`tc-toggle ${className}`} {...otherProps} />;
};
